function createSignupFormMessage(messageText) {
    var fragment = document.createDocumentFragment(),
        temp = document.createElement('small');
    temp.classList.add('newsletter-form__message');
    temp.classList.add('form__message');
    temp.innerHTML = messageText;

    while (temp.firstChild) {
        fragment.appendChild(temp.firstChild);
    }
    return fragment;
}

async function onSubmitSignupForm(event) {
  const signupForm = document.getElementById('contact_form');
  const clientId = 'efd64074d4d5d424a92a570f6438ccd0f84e82ffc16d87c4af70d4626ade6882';
  const formId = '-NC_Lo-QMm48IRTLazsH'; // old: -NAOm4lLAnsAR6P7Gmwy, new: -NC_Lo-QMm48IRTLazsH
  const url = 'https://forms.umusic-online.com/api/v1/forms/' + formId + '/subscription';
  const emailField = signupForm.querySelector('input[name="email"]');
  const email = emailField.value;
  const consumerCountry = signupForm.querySelector('input[name="consumer_country"]').value;
  const dmAddressBooks = [10669665];
  const data = {
    'client_id': clientId,
    'email': email,
    'consumer_country': consumerCountry,
    'dm_addressbooks': [10669665],
    'acquisition_sys': 'website',
    'acquisition_source': 'artist_website'
  }

  emailField.setAttribute('disabled', 'true');

  // Post data to UMG Data Acquisition API
  // @see https://forms.umusic-online.com/builder/documentation
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
    
  await response.json().then(responseBody => {
    const formFieldWrapper = signupForm.querySelectorAll(".newsletter-form__field-wrapper")[0];
    const previousMessage = document.getElementById('newsletter-message');
    let messageText = responseBody.message;
    
    if (previousMessage != null) {
      previousMessage.remove();
    }
    emailField.removeAttribute('disabled', 'true');
    
    // Optionally replace the messageText values in the following if statement 
    // to customize text displayed after registration is successful or fails
    if (response.status === 200) {
      // "Successfully subscribed"
      messageText = responseBody.message;
      
      // Clear email address after successful registration
      emailField.value = null;
    } else if (response.status === 422) {
      // "Email address is not valid"
      messageText = responseBody.errors[0].message;
    } else {
      // Other errors...
      messageText = 'Something went wrong, please try again later. (Status code: ' + response.status + ')';
    }

    const messageElement = createSignupFormMessage('<span id="newsletter-message" class="newsletter-form__message form__message">' + messageText + '</span>');
    formFieldWrapper.append(messageElement);
  });

}

function registerSignupFormEventListener() {
  const signupForm = document.getElementById('contact_form');
  
  if (signupForm != null && signupForm.length !== -1) {
    signupForm.setAttribute('onsubmit', 'return false;');
    signupForm.setAttribute('action', '');
    signupForm.addEventListener('submit', onSubmitSignupForm);
    
    signupForm.addEventListener('formdata', (event) => {
      console.log('formdata', event);
    });
  }
}

registerSignupFormEventListener();